import Swiper from 'swiper/dist/js/swiper.js';

function init() {
  const propertygallerySwiper = document.querySelector('.propertygallery__swiper');
  const propertygallerySwiperSelector = '.swiper-container.propertygallery__swiper';

  if (propertygallerySwiper) {
    const swiper = new Swiper (propertygallerySwiperSelector, {
      direction: 'horizontal',
      speed: 1000,
      loop: true,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
    });
  }
}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Propertygallery.js